import { ReportData } from '@/types/domain';
import { SelectOption } from '../../../components/common/Dropdown/types';

type CrmLibraryItemGridPreviewProps = {
  visibleColumns: string[];
  displayBy?: string;
  displayByLabel: string;
  noResult?: number;
  sortColumnLabel: string;
  sortDesc?: boolean;
  dropdownOptions?: {
    visibleColumnsOptions: SelectOption[];
  };
  reportData?: ReportData | null;
}

export const CrmLibraryItemGridPreview = ({ sortColumnLabel: sortColumnLabel, sortDesc, reportData }: CrmLibraryItemGridPreviewProps) => {
  if (!reportData || !reportData.columns || !reportData.rows) {
    return (
      <div className="bg-gray-50 rounded-lg p-8 text-center">
        <p className="text-gray-500">No data available</p>
      </div>
    );
  }

  const parsedRows = reportData.rows.map((row: any) => {
    if (row.cells && Array.isArray(row.cells)) {
      return row.cells.map((cell: any) => cell.value);
    }
    return [];
  });

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full">
        <thead className="bg-table-header border-t border-b border-table-border">
          <tr>
            {reportData.columns.map((column, index) => (
              <th key={index} className="px-4 py-3 text-left text-sm font-medium text-table-header-foreground">
                {column.name}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="bg-white">
          {parsedRows.map((row: string[], rowIndex: number) => (
            <tr key={rowIndex} className="border-b hover:bg-gray-50">
              {row.map((cellValue: string, cellIndex: number) => (
                <td key={cellIndex} className="px-4 py-3 text-sm text-gray-600">
                  {cellValue}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>

      <div className="mt-3 text-center">
        <p className="text-xs text-gray-500">
          Showing {parsedRows.length} rows with actual data •
          Sorted by {sortColumnLabel !== undefined ? sortColumnLabel : 'Not set'}{sortDesc ? ' (Descending)' : ' (Ascending)'}
        </p>
      </div>
    </div>
  );
};